



































import { Component, Vue } from 'vue-property-decorator';
import AddIcon from 'mdi-vue/Plus';
import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import Header from '@/components/Table/Header.vue';
import SubHeader from '@/components/Table/SubHeader.vue';
import Loader from '@/components/Loader.vue';
import Button from '@/components/Button.vue';
import SprintUserReportTable from './SprintUserReportTable.vue';

@Component({
  components: {
    LayoutTitle,
    LayoutContent,
    Header,
    SubHeader,
    Loader,
    Button,
    AddIcon,
    SprintUserReportTable,
  },
})
export default class SprintUserReport extends Vue {
  $refs!: {
    report: SprintUserReportTable;
  }
}
